import { useEffect, useState } from "react";
import useFirestore from "../common/useFirestore"
import useCrypto from "../common/useCrypto";
import { useNavigate } from "react-router-dom";

function useComparePassword(){
    const navigate = useNavigate();
    const {decrypto} = useCrypto();
    const {readFirestoreOneDoc} = useFirestore();
    const [input, setInput] = useState("");
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [id, setId] = useState("");

    const isPasswordMatched = async(id) => {
        const result = readFirestoreOneDoc("Inquiry", id).then(res => {
            if(res.exists()){
                if(decrypto(res.data().password) === input){
                    return true;
                }
            }
            return false;
        })
        return result;
    }

    const onChange = (e) => {
        setInput(e.target.value);
    }

    const onComparePasswordHandler = (id) => {
        setId(id);
        setShowPasswordModal(true);
    }

    const onConfirmClick = () => {
        isPasswordMatched(id).then(res => {
            if(res){
                navigate("/inquiry/detail", {state:id});
            }else{
                setShowErrorModal(true);
            }
        })
    }
    
    
    return {input, onChange,  showErrorModal, setShowErrorModal, showPasswordModal, setShowPasswordModal, onComparePasswordHandler, onConfirmClick}
}

export default useComparePassword;